(() => {
  const bar = document.getElementById('fixed-cta-bar');
  if (!bar) return;

  const variantInput = bar.querySelector('.fixed-cta-bar__variant-id');
  const submitButton = bar.querySelector('.fixed-cta-bar__button');
  const submitLabel = bar.querySelector('[data-fixed-cta-label]');
  const priceNode = bar.querySelector('[data-fixed-cta-price]');

  let visibilityObserver;
  let resizeObserver;
  let mainSubmitInView = true;

  const getCurrentProductInfo = () => document.querySelector('product-info[id^="MainProduct-"]');

  const getMainProductForm = () => {
    const productInfo = getCurrentProductInfo();
    if (!productInfo) return null;
    const form = productInfo.querySelector('form[data-type="add-to-cart-form"]');
    if (!form) return null;

    return {
      productInfo,
      form,
      idInput: form.querySelector('input[name="id"].product-variant-id'),
      submit: form.querySelector('button[name="add"]'),
    };
  };

  const getPriceText = (root) => {
    if (!root) return '';

    const selectors = [
      '.price__sale .price-item--sale',
      '.price .price-item--sale',
      '.price__regular .price-item--regular',
      '.price .price-item--regular',
    ];

    for (let i = 0; i < selectors.length; i++) {
      const node = root.querySelector(selectors[i]);
      const value = node?.textContent?.trim();
      if (value) return value;
    }

    return '';
  };

  const setSubmitState = (enabled, label) => {
    const isEnabled = Boolean(enabled);
    if (variantInput) variantInput.disabled = !isEnabled;
    if (submitButton) {
      submitButton.disabled = !isEnabled;
      submitButton.setAttribute('aria-disabled', String(!isEnabled));
    }
    if (label && submitLabel) submitLabel.textContent = label;
  };

  const updateBarVisibility = () => {
    const hasVariant = Boolean(variantInput?.value);
    const shouldShow = hasVariant && !mainSubmitInView && window.scrollY > 120;

    bar.classList.toggle('fixed-cta-bar--active', shouldShow);
    document.body.classList.toggle('fixed-cta-bar-visible', shouldShow);
  };

  const syncFromMainForm = () => {
    const main = getMainProductForm();
    if (!main || !main.idInput) {
      updateBarVisibility();
      return;
    }

    variantInput.value = main.idInput.value || '';

    const labelFromMain = main.submit?.querySelector('span')?.textContent?.trim();
    const fallbackLabel = main.submit?.hasAttribute('disabled')
      ? window.variantStrings?.soldOut
      : window.variantStrings?.addToCart;

    setSubmitState(!main.submit?.hasAttribute('disabled'), labelFromMain || fallbackLabel || '');

    const currentPrice = getPriceText(main.productInfo);
    if (currentPrice && priceNode) priceNode.textContent = currentPrice;

    updateBarVisibility();
  };

  const observeMainSubmitVisibility = () => {
    visibilityObserver?.disconnect();
    resizeObserver?.disconnect();

    const main = getMainProductForm();
    const mainSubmit = main?.submit;

    if (!mainSubmit) {
      mainSubmitInView = false;
      updateBarVisibility();
      return;
    }

    visibilityObserver = new IntersectionObserver(
      (entries) => {
        mainSubmitInView = entries[0]?.isIntersecting ?? false;
        updateBarVisibility();
      },
      { threshold: 0.25 }
    );
    visibilityObserver.observe(mainSubmit);

    if (window.ResizeObserver) {
      resizeObserver = new ResizeObserver(() => updateBarVisibility());
      resizeObserver.observe(mainSubmit);
    }
  };

  const onVariantChanged = (event) => {
    const variant = event?.data?.variant;
    if (variant?.id && variantInput) variantInput.value = variant.id;

    if (variant) {
      setSubmitState(
        Boolean(variant.available),
        variant.available ? window.variantStrings?.addToCart : window.variantStrings?.soldOut
      );
    }

    const sectionId = event?.data?.sectionId;
    const html = event?.data?.html;
    const sourceRoot = sectionId && html ? html.getElementById(`price-${sectionId}`) : html;
    const nextPrice = getPriceText(sourceRoot);
    if (nextPrice && priceNode) priceNode.textContent = nextPrice;

    requestAnimationFrame(() => {
      syncFromMainForm();
      observeMainSubmitVisibility();
    });
  };

  document.addEventListener('change', (event) => {
    if (event.target?.matches?.('input[name="id"].product-variant-id')) {
      syncFromMainForm();
      observeMainSubmitVisibility();
    }
  });

  document.addEventListener('product-info:loaded', () => {
    syncFromMainForm();
    observeMainSubmitVisibility();
  });

  window.addEventListener(
    'scroll',
    () => {
      updateBarVisibility();
    },
    { passive: true }
  );

  window.addEventListener('resize', updateBarVisibility);

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, onVariantChanged);
  }

  syncFromMainForm();
  observeMainSubmitVisibility();
})();
